import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly activeRequests = signal(0);
  readonly isLoading = computed(() => this.activeRequests() > 0);

  toggleLoader(serviceFlag: number) {
    switch (serviceFlag) {
      case 0:
        this.activeRequests.update(count => Math.max(0, count - 1));
        break;
      case 1:
        this.activeRequests.update(count => count + 1);
        break;
    }
  }
}
